export function runSteppedRules(transaction, rules, stepSeconds) {
    for (const rule of [...rules].sort(compareRules)) {
        if (transaction.isScopeActive(rule.scope))
            rule.update(transaction, stepSeconds);
    }
}
function compareRules(left, right) {
    if (left.priority !== right.priority)
        return left.priority - right.priority;
    return Number(left.id > right.id) - Number(left.id < right.id);
}
//# sourceMappingURL=rules.js.map